import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { formatNumber } from '@utils/index'
import { LegendData } from '@dataTypes/dashboard.types'

type CardContentProps = {
  title?: string
  content: React.ReactElement
  legendData?: LegendData[]
  classNameCol?: string
}

function CardContent({
  title,
  content,
  legendData,
  classNameCol,
}: CardContentProps): React.ReactElement {
  return (
    <Row className="text-center">
      <Col>{title}</Col>
      <Col md={12}>{content}</Col>
      <Col md={12} className="justify-content-center">
        <Row>
          {legendData &&
            legendData.map(({ name, value, showCurrency }) => (
              <Col className={`${classNameCol ?? 'col-md-3'}`} key={`${name}`}>
                <div className="text-black">{name}</div>
                <div className="text-black fw-bolder">
                  {formatNumber(value, showCurrency)}
                </div>
              </Col>
            ))}
        </Row>
      </Col>
    </Row>
  )
}

export default CardContent
